// 微信sdk
import apis from '@/api'
import Vue from 'vue'
import wx from 'weixin-js-sdk'

/**
 * 微信sdk初始化
 * 由于vue是单页面，所以可直接在App.vue里初始化一次即可
 */
export function wxSdkInit() {
  const url = window.location.href
  const jsApiList = ['getLocation', 'scanQRCode', 'chooseImage', 'getLocalImgData']
  const request = { ...apis.ACCOUNT.WX_SIGN }
  request.params = {
    url
  }
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  if (isiOS) {
    setTimeout(() => {
      Vue.prototype.$bus.$emit(`getLocationEvent`, '', {
        opt: 'STARTS_WITH'
      })
    }, 100)
    if (arguments && arguments[0]) {
    } else {
      if (Vue.prototype.$wxSignInIos) {
        return
      }
    }
  }

  Vue.prototype.$wxSignInIos = true
  Vue.prototype
    .$request(request, false)
    .asyncThen(
      (resp) => {
        wx.config({
          debug: false,
          signature: resp.data.signature,
          nonceStr: resp.data.nonceStr,
          timestamp: resp.data.timestamp,
          appId: resp.data.appId,
          jsApiList
        })
        wx.error((res) => {
          Vue.prototype.$wxSignInIos = false
          // console.log(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
        wx.ready((res) => {
          Vue.prototype.$wxSignInIos = true
          Vue.prototype.$bus.$emit(`getLocationEvent`, '', {
            opt: 'STARTS_WITH'
          })
          if (arguments && arguments[0]) {
            Vue.prototype.$bus.$emit(`getOcrInit`, '', {
              opt: 'STARTS_WITH'
            })
          }
          // console.log(res)
        })
      },
      (err) => {
        console.error(err)
      }
    )
    .asyncErrorCatch((err) => {
      console.error(err)
    })
}

/**
 * 微信获取定位接口
 * @param showMessage 是否显示message
 * @param callback 回调：定位成功，回调为火星坐标的经纬度，否则回调为空
 */
export function wxGetLocation(showMessage, callback) {
  wx.getLocation({
    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success: (res) => {
      var lat = res.latitude // 纬度，浮点数，范围为90 ~ -90
      var lng = res.longitude // 经度，浮点数，范围为180 ~ -180。
      callback({
        lat,
        lng
      })
    },
    fail: (error) => {
      if (showMessage) {
        Vue.prototype.$message({
          type: 'error',
          message: `微信定位失败，请稍后重试`
        })
      }
      callback()
    },
    cancel: (error) => {
      if (showMessage) {
        Vue.prototype.$message({
          type: 'error',
          message: `微信定位失败，请稍后重试`
        })
      }
      callback()
    }
  })
}

/**
 * 扫码
 * @param callback
 */
export function wxScanQRCode(callback) {
  wx.scanQRCode({
    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
    success: function(res) {
      var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
      callback({
        result
      })
    },
    fail: (error) => {
      callback()
    },
    cancel: (error) => {
      callback()
    }
  })
}

// 拍照或从手机相册中选图接口
export function wxOpenCameraApi(cb) {
  wx.chooseImage({
    count: 1, // 默认9
    sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
    success: function (res) {
      var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      getWxLocalImgData(localIds, cb)
    },
    fail: (error) => {
      console.log('失败', error)
      cb()
    },
    cancel: (error) => {
      console.log('取消', error)
      cb()
    }
  })
}

export function getWxLocalImgData(localIds, cb) {
  wx.getLocalImgData({
    localId: localIds[0].toString(),
    success: function (res) {
      const localData = res.localData
      let imageBase64 = ''
      if (localData.indexOf('data:image') === 0) {
        // 苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
        imageBase64 = localData
      } else {
        // 此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
        // 此时一个正常的base64图片路径就完美生成赋值到img的src中了
        imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '')
      }
      cb(imageBase64)
    }
  })
}
